module.exports = __webpack_public_path__ + "img/tanyueDesc.8003378e.jpeg";